// ::: Code Generated by Copilot 8c6ce7cc-5f4f-4ee2-8103-cf96e5131c4c. This comment will be removed automatically after the file is saved :::
import NavToggle from './NavToggle';
import DisplayNameBadge from './DisplayNameBadge';
import LogoutButton from './LogoutButton';
import { Box } from '@mui/material';
import NavListItem from './NavListItem';
import { DEFAULT, LEAVE_FEEDBACK, REPORT_AN_ISSUE, INSIGHT_IQ_ASSISTANT } from '../../constants/navigation';
import ApolloReactComponent, { ACTION_TYPE } from '../../components/ApolloReactComponent';
import InsightIQChat, { InsightIQChatMethods } from '../../components/InsightIQChat';
import { Dispatch, SetStateAction, useState, useRef } from 'react';
import { getProdFlag } from '../../utils/envVals';

interface IUserActions {
    actionKey: string;
    setActionType: Dispatch<SetStateAction<"REPORT_ISSUE" | "PUSH_FEEDBACK" | "DEFAULT" | "INSIGHT_IQ_ASSISTANT">>
}

const isProduction = getProdFlag()
const actionTypes: { [actionKey: string]: keyof typeof ACTION_TYPE } = {
    [DEFAULT]: "DEFAULT",
    [REPORT_AN_ISSUE]: "REPORT_ISSUE",
    [LEAVE_FEEDBACK]: "PUSH_FEEDBACK",
    [INSIGHT_IQ_ASSISTANT]: "INSIGHT_IQ_ASSISTANT"
}

const NavBottomGroup = (props: any) => {
    const { handleToggleDrawer, open, userProfile, bottomGroup = [] } = props
    const [actionType, setActionType] = useState(actionTypes[DEFAULT]);
    // ::: Code Generated by Copilot 8c6ce7cc-5f4f-4ee2-8103-cf96e5131c4c. This comment will be removed automatically after the file is saved :::
    const insightIQChatRef = useRef<InsightIQChatMethods>(null);

    const handleChatClick = async () => {
        console.log('NavBottomGroup: Chat button clicked');
        try {
            if (insightIQChatRef.current?.isReady()) {
                console.log('NavBottomGroup: Opening InsightIQ chat...');
                await insightIQChatRef.current.openChat();
            } else {
                console.warn('NavBottomGroup: InsightIQ chat not ready yet. Chat ref:', !!insightIQChatRef.current);
                // TODO: Show user-friendly message or loading indicator
            }
        } catch (error) {
            console.error('NavBottomGroup: Failed to open InsightIQ chat:', error);
        }
    };

    const UserAction = ({ actionKey, setActionType }: IUserActions) => {
        switch (actionKey) {
            case LEAVE_FEEDBACK:
                return <NavListItem iconName='leave_feedback' label={LEAVE_FEEDBACK} onClick={() => setActionType(actionTypes[LEAVE_FEEDBACK])} />;
            case REPORT_AN_ISSUE:
                return <NavListItem iconName='report_issue' label={REPORT_AN_ISSUE} onClick={() => setActionType(actionTypes[REPORT_AN_ISSUE])} />;
            case INSIGHT_IQ_ASSISTANT:
                return isProduction ? null : <NavListItem
                    iconName='insight_chat'
                    label={INSIGHT_IQ_ASSISTANT}
                    onClick={handleChatClick}
                />
            default:
                return null;
        }
    }

    return (
        <Box className="nav-bottom-group">
            <Box className="nav-bottom-group-content">
                <NavToggle open={open} onToggle={handleToggleDrawer} />
                <DisplayNameBadge displayName={userProfile.displayName} />
                {
                    Array.isArray(bottomGroup) ?
                        bottomGroup.map(groupKey => {
                            return <UserAction key={groupKey} actionKey={groupKey} setActionType={setActionType} />
                        }) : null
                }
                <LogoutButton />
            </Box >
            <ApolloReactComponent actionType={actionType} closeModal={() => setActionType(DEFAULT)} userProfile={userProfile} />

            <InsightIQChat ref={insightIQChatRef} />
        </Box >
    )
}

export default NavBottomGroup;